import useFetch from '@hooks/useFetch';
import processRecentSearchesData from '@api/processors/search';
import { getIsLoggedIn } from '@api/selectors/auth';
import { readCookie } from '@utils/cookies';
import useMyInfo from '../auth/useMyInfo';

const useRecentSearches = (goalUID, shouldFetch = false) => {
  const key = `plus_search/home?goal_uid=${goalUID}&version=2`;
  const isLoggedIn = useMyInfo(getIsLoggedIn);
  const searchToken = readCookie('searchToken');
  const { data: recentSearchesData, ...rest } = useFetch(
    isLoggedIn && goalUID && searchToken && shouldFetch ? key : null,
    { useSearchToken: true, useAuthToken: false }
  );
  return {
    recentSearches: processRecentSearchesData(recentSearchesData),
    ...rest
  };
};

export default useRecentSearches;
